import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import MUIDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import logoBlue from "assets/dsv-logo-blue.svg";
import { userStore } from "entities/User/store/userStore";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useNavLinks } from "shared/hooks/useNavLinks";
import Icons from "shared/icons";
import { DrawerFooter } from "../DrawerFooter/DrawerFooter";

function Drawer(props) {
  const {
    window,
    handleDrawerToggle,
    mobileOpen,
    handleTesterDrawerToggle,
    handleLogout,
  } = props;
  const { t } = useTranslation("shared");
  const container =
    window !== undefined ? () => window().document.body : undefined;

  const { drawerLinks } = useNavLinks();
  const isUserTester = userStore((state) => state.isUserTester);

  return (
    <MUIDrawer
      container={container}
      variant="temporary"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: "80%",
        },
      }}
    >
      <Box
        sx={{
          color: "#002664",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={handleDrawerToggle}
      >
        <Box
          sx={{
            display: "flex",
            my: 2,
            mx: 2,
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Typography variant="h6">
            <Link to="/" target="_self">
              <img src={logoBlue} width="100" height="auto" alt="DSV" />
            </Link>
          </Typography>
          <IconButton
            size="large"
            color="inherit"
            aria-label="close-drawer"
            sx={{
              fontSize: "1.2rem",
              display: { md: "none" },
            }}
          >
            <FontAwesomeIcon icon={Icons.close} />
          </IconButton>
        </Box>

        <Divider />
        <List sx={{ px: 2 }}>
          {drawerLinks.map(({ link, href, label, icon, render }, idx) => {
            if (render)
              return <Fragment key={idx}>{render("drawer")}</Fragment>;
            if (href)
              return (
                <ListItem key={href} disablePadding>
                  <ListItemButton component="a" href={href} target="_blank">
                    {icon}
                    <ListItemText primary={label} className="ms-3" />
                  </ListItemButton>
                </ListItem>
              );
            return (
              <ListItem key={link} disablePadding>
                <ListItemButton component={Link} to={link}>
                  {icon}
                  <ListItemText primary={label} className="ms-3" />
                </ListItemButton>
              </ListItem>
            );
          })}
          <Divider />
          {isUserTester && (
            <ListItem disablePadding>
              <ListItemButton onClick={handleTesterDrawerToggle}>
                <Icons.bugReport />
                <ListItemText primary={t("tester_panel")} className="ms-3" />
              </ListItemButton>
            </ListItem>
          )}
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout}>
              <FontAwesomeIcon icon={Icons.arrowRightFromBracket} />
              <ListItemText primary={t("logout")} className="ms-3" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
      <DrawerFooter />
    </MUIDrawer>
  );
}

export default Drawer;
